import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dc1f815"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animated" }
const _hoisted_2 = { class: "card card-xl-stretch mb-6 bg-transparent" }
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<a href=\"https://hakaisecurity.io/quimera-team/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-5dc1f815><img src=\"/media/logo-amarelo-clean.png\" style=\"width:150px;\" alt=\"QuimeraX\" data-v-5dc1f815></a><h4 class=\"font-monospace fs-1 mt-2\" data-v-5dc1f815> Bem-vindo ao <a class=\"fw-bold text-white\" href=\"https://hakaisecurity.io/quimera-team/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-5dc1f815>Quimera X</a></h4><p class=\"font-monospace\" data-v-5dc1f815> Fique informado com as últimas atualizações com o QuimeraX News </p>", 3)
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = { class: "col-md-8 col-lg-6" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-start mt-1" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode(" Aceita sintaxe Elasticsearch: "),
    /*#__PURE__*/_createElementVNode("code", null, "AND"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "OR"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "NOT"),
    /*#__PURE__*/_createTextVNode(", aspas e curingas. ")
  ])
], -1))
const _hoisted_16 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Somente para assinantes do ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-info" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/profile/billing",
    class: "text-info"
  }, "plano completo")
], -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "col-md-12 position-relative"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blur-overlay font-sans" }, [
  /*#__PURE__*/_createTextVNode(" Assine o plano completo para ter acesso ao QuimeraX News "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/profile/billing",
    class: "btn btn-light-primary fw-bolder py-2 px-5 mt-3 mb-2"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-square-fill" }),
    /*#__PURE__*/_createTextVNode(" Quero assinar o plano completo ")
  ])
], -1))
const _hoisted_22 = { class: "blur-content" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/logo-amarelo-clean.png",
  style: {"width":"90px","object-fit":"contain"},
  alt: ""
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger mb-2" }, "critical"),
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-3" }, "Ameaça de ransomware direcionada a grandes organizações"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Resumo gerado por IA sobre o incidente, indicadores, atores e setores afetados…")
], -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "d-flex justify-content-center mb-6" }
const _hoisted_27 = { class: "nav nav-pills nav-pills-custom" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-newspaper me-1" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Feed")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart-line me-1" }, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Dashboard")
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon-fill fs-2 me-3" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Serviço de notícias indisponível."),
  /*#__PURE__*/_createTextVNode(" A integração não está configurada corretamente. Já avisamos o time — tente novamente mais tarde. ")
], -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "row"
}
const _hoisted_41 = { class: "col-lg-3 order-lg-1 order-2" }
const _hoisted_42 = {
  key: 0,
  class: "card mb-6"
}
const _hoisted_43 = { class: "card-body p-4" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel text-warning me-1" }),
  /*#__PURE__*/_createTextVNode(" Filtros")
], -1))
const _hoisted_45 = { class: "mb-4" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 text-uppercase mb-2" }, "Criticidade", -1))
const _hoisted_47 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "text-muted fs-8 text-uppercase mb-2" }
const _hoisted_50 = { class: "d-flex flex-column gap-1" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "text-truncate me-2" }
const _hoisted_53 = { class: "badge badge-light" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 1,
  class: "card mb-6"
}
const _hoisted_56 = { class: "card-body p-4" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-activity text-warning me-1" }),
  /*#__PURE__*/_createTextVNode(" Atividade recente")
], -1))
const _hoisted_58 = { class: "d-flex flex-column gap-3" }
const _hoisted_59 = { class: "d-flex align-items-center gap-1 fs-8 text-muted" }
const _hoisted_60 = {
  key: 0,
  class: "badge badge-light-success py-0"
}
const _hoisted_61 = { class: "ms-auto" }
const _hoisted_62 = { class: "fs-7 fw-semibold" }
const _hoisted_63 = { class: "col-lg-9 order-lg-2 order-1" }
const _hoisted_64 = { class: "d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, [
  /*#__PURE__*/_createTextVNode(" Breaking News 🚨 "),
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-warning" }),
    /*#__PURE__*/_createTextVNode(" Beta")
  ])
], -1))
const _hoisted_66 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_67 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mb-4 align-items-center"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" }, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle me-1" }, null, -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Busca inválida: ")
const _hoisted_74 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center py-10"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hollow-dots-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 3,
  class: "text-center py-10 text-muted"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-inbox fs-3x d-block mb-3" }, null, -1))
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Nenhum caso encontrado. ")
const _hoisted_80 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_81 = { class: "card mb-4 card-hover" }
const _hoisted_82 = { class: "card-body p-4" }
const _hoisted_83 = { class: "d-flex align-items-center gap-2 mb-2 fs-8 text-muted" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 2,
  class: "badge badge-light-success py-0"
}
const _hoisted_87 = { class: "fs-3 text-gray-900 mb-2" }
const _hoisted_88 = ["innerHTML"]
const _hoisted_89 = { class: "d-flex gap-4 mt-3 fs-8 text-muted" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers me-1" }, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-broadcast me-1" }, null, -1))
const _hoisted_92 = { class: "d-flex align-items-center justify-content-between mt-6" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" Anterior ")
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = { class: "text-muted fs-7" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" Próxima ")
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
const _hoisted_101 = [
  _hoisted_99,
  _hoisted_100
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewsDashboard = _resolveComponent("NewsDashboard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
                  disabled: !_ctx.allowed,
                  name: "search",
                  type: "text",
                  class: "form-control",
                  placeholder: "Ex.: ransomware healthcare, criticity:critical, cves:CVE-2026-*",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitSearch && _ctx.submitSearch(...args)), ["enter"]))
                }, null, 40, _hoisted_11), [
                  [_vModelText, _ctx.searchInput]
                ]),
                _createElementVNode("button", {
                  disabled: !_ctx.allowed,
                  class: "btn btn-secondary",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitSearch && _ctx.submitSearch(...args)))
                }, _hoisted_14, 8, _hoisted_12)
              ]),
              _hoisted_15
            ])
          ]),
          (!_ctx.allowed)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.allowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "bg-gray-100 rounded d-flex gap-4 mt-2 p-4"
              }, _hoisted_25)
            }), 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", _hoisted_28, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["nav-link px-6 py-2", _ctx.tab === 'feed' ? 'active' : '']),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setTab('feed')), ["prevent"]))
                }, _hoisted_31, 2)
              ]),
              _createElementVNode("li", _hoisted_32, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["nav-link px-6 py-2", _ctx.tab === 'dashboard' ? 'active' : '']),
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setTab('dashboard')), ["prevent"]))
                }, _hoisted_35, 2)
              ])
            ])
          ]),
          (_ctx.tab === 'dashboard')
            ? (_openBlock(), _createBlock(_component_NewsDashboard, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.challenge)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        (_ctx.facets.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _hoisted_44,
                                _createElementVNode("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createElementVNode("div", _hoisted_47, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticityOrder, (level) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: level,
                                        type: "button",
                                        class: _normalizeClass(["btn btn-sm py-1 px-2", _ctx.currentCriticity === level ? `btn-${_ctx.criticityColor(level)}` : `btn-light-${_ctx.criticityColor(level)}`]),
                                        onClick: ($event: any) => (_ctx.toggleCriticity(level))
                                      }, _toDisplayString(level), 11, _hoisted_48))
                                    }), 128))
                                  ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accumulatingFacets, (facet) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: facet.field,
                                    class: "mb-4"
                                  }, [
                                    _createElementVNode("div", _hoisted_49, _toDisplayString(facet.label), 1),
                                    _createElementVNode("div", _hoisted_50, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleBuckets(facet), (b) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          key: b.key,
                                          href: "#",
                                          class: _normalizeClass(["d-flex justify-content-between text-hover-primary", _ctx.isClauseActive(facet.field, b.key) ? 'fw-bold text-primary' : 'text-muted']),
                                          onClick: _withModifiers(($event: any) => (_ctx.applyClause(facet.field, b.key)), ["prevent"])
                                        }, [
                                          _createElementVNode("span", _hoisted_52, _toDisplayString(b.key), 1),
                                          _createElementVNode("span", _hoisted_53, _toDisplayString(b.count), 1)
                                        ], 10, _hoisted_51))
                                      }), 128))
                                    ]),
                                    (facet.buckets.length > _ctx.facetLimit)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: "#",
                                          class: "fs-8 text-muted d-inline-block mt-1",
                                          onClick: _withModifiers(($event: any) => (_ctx.toggleFacetExpanded(facet.field)), ["prevent"])
                                        }, _toDisplayString(_ctx.expandedFacets.includes(facet.field) ? "ver menos" : `ver mais (${facet.buckets.length - _ctx.facetLimit})`), 9, _hoisted_54))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.updates.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createElementVNode("div", _hoisted_58, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updates, (u) => {
                                    return (_openBlock(), _createBlock(_component_router_link, {
                                      key: u.uuid + u.collected_at,
                                      to: `/apps/quimerax-news/${u.uuid}`,
                                      class: "text-decoration-none text-gray-800 text-hover-primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_59, [
                                          (u.is_first)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, "novo"))
                                            : _createCommentVNode("", true),
                                          (_ctx.normalizeCriticity(u.criticity))
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: _normalizeClass(`badge badge-light-${_ctx.criticityColor(u.criticity)} py-0`)
                                              }, _toDisplayString(_ctx.normalizeCriticity(u.criticity)), 3))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", null, _toDisplayString(u.source_host), 1),
                                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.formatRelative(u.collected_at)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_62, _toDisplayString(u.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          (_ctx.result && !_ctx.result.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.result.total) + " casos · página " + _toDisplayString(_ctx.result.page) + "/" + _toDisplayString(Math.max(_ctx.result.total_pages, 1)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.activeClauses.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeClauses, (clause) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: clause,
                                  class: "badge badge-light-primary d-flex align-items-center gap-1 py-2"
                                }, [
                                  _createTextVNode(_toDisplayString(clause) + " ", 1),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "text-primary",
                                    onClick: _withModifiers(($event: any) => (_ctx.removeClause(clause)), ["prevent"])
                                  }, _hoisted_70, 8, _hoisted_68)
                                ]))
                              }), 128)),
                              _createElementVNode("a", {
                                href: "#",
                                class: "fs-8 text-muted",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)), ["prevent"]))
                              }, "limpar tudo")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.result && _ctx.result.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _hoisted_72,
                              _hoisted_73,
                              _createElementVNode("code", null, _toDisplayString(_ctx.result.error), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
                          : (_ctx.result && !_ctx.result.error && _ctx.result.cases.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                _hoisted_78,
                                _hoisted_79,
                                (_ctx.q)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)), ["prevent"]))
                                      }, "Limpar a busca")
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.result)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.cases, (c) => {
                                    return (_openBlock(), _createBlock(_component_router_link, {
                                      key: c.uuid,
                                      to: `/apps/quimerax-news/${c.uuid}`,
                                      class: "d-block text-decoration-none"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_81, [
                                          _createElementVNode("div", _hoisted_82, [
                                            _createElementVNode("div", _hoisted_83, [
                                              (c.latest_source_host)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: `https://www.google.com/s2/favicons?sz=32&domain=${c.latest_source_host}`,
                                                    style: {"width":"16px","height":"16px"},
                                                    alt: ""
                                                  }, null, 8, _hoisted_84))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", null, _toDisplayString(c.latest_source_host || "—"), 1),
                                              (c.latest_at)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_85, "· " + _toDisplayString(_ctx.formatRelative(c.latest_at)), 1))
                                                : _createCommentVNode("", true),
                                              (_ctx.isRecent(c.latest_at))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_86, "atualizado"))
                                                : _createCommentVNode("", true),
                                              (_ctx.normalizeCriticity(c.criticity))
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 3,
                                                    class: _normalizeClass(`badge badge-light-${_ctx.criticityColor(c.criticity)} ms-auto`)
                                                  }, _toDisplayString(_ctx.normalizeCriticity(c.criticity)), 3))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("h4", _hoisted_87, _toDisplayString(c.title), 1),
                                            _createElementVNode("div", {
                                              class: "text-gray-700 trf-summary",
                                              innerHTML: _ctx.renderMarkdown(c.summary)
                                            }, null, 8, _hoisted_88),
                                            _createElementVNode("div", _hoisted_89, [
                                              _createElementVNode("span", null, [
                                                _hoisted_90,
                                                _createTextVNode(_toDisplayString(c.update_count) + " atualizações", 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_91,
                                                _createTextVNode(_toDisplayString(c.source_count) + " fontes", 1)
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  }), 128)),
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("button", {
                                      class: "btn btn-light-primary",
                                      disabled: !_ctx.result.has_prev,
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage(_ctx.result.page - 1)))
                                    }, _hoisted_96, 8, _hoisted_93),
                                    _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.result.start_index) + "–" + _toDisplayString(_ctx.result.end_index) + " de " + _toDisplayString(_ctx.result.total), 1),
                                    _createElementVNode("button", {
                                      class: "btn btn-light-primary",
                                      disabled: !_ctx.result.has_next,
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage(_ctx.result.page + 1)))
                                    }, _hoisted_101, 8, _hoisted_98)
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
                      ])
                    ]))
              ], 64))
        ], 64))
  ]))
}